<template>
	<div class="app-container">
		<div class="iphone">
			<div class="iphone-overflow">
				<div class="iphone-header">
					<div class="iphone-header-logo">
						<van-image
							width="3rem"
							height="3rem"
							radius=".2rem"
							:src="shopInfo.logo ? shopInfo.logo : ''"
						/>
					</div>
					<div class="iphone-header-content">
						<van-col span="24">
							<h3 class="iphone-header-title">{{shopInfo.name}}</h3>
							<p class="iphone-header-desc">{{shopInfo.about}}</p>
						</van-col>
						<!-- <van-col v-if="shopInfo.msg">
							<van-tag type="success" @click="prerviewImages" class="iphone-header-msg" round><van-icon name="service-o" /> 客服</van-tag>
						</van-col> -->
					</div>
				</div>
				<van-notice-bar
				    class="notice-swipe"
					left-icon="volume-o"
					:text="shopInfo.note"
				/>
				<van-swipe :autoplay="3000" lazy-render class="iphone-swipe">
					<van-swipe-item v-for="item in shopInfo.banner">
						<template v-if="item.type == 'link'">
							<a :href="item.url" target="_blank" v-if="item.url"><img :src="item.image" /></a>
							<img v-else :src="item.image" />
						</template>
						<template v-else>
							<router-link :to="'/' + $store.getters.shop.shop_key +'/product/' + item['url']">
								<img :src="item.image" />
							</router-link>
						</template>
					</van-swipe-item>
				</van-swipe>
				<van-tabs v-model:active="hot_active" color="#1989fa" animated @change="change_active">
					<template v-for="(item, index) in tabs">
						<van-tab :title="item.name" :name="item.key" v-if="index < 5">
							<div style="padding-bottom: 1rem;">
							<div class="iphone-pro" v-for="item in productList[item.key]">
								<van-card
									:price="item.price.toFixed(2)"
									:desc="item.about"
									:title="item.name"
									:thumb="item.image"
									:origin-price="item.kprice.toFixed(2)"
									@click="openProductInfo(item)"
								>
									<template #origin-price>
										{{item.sales}}人付款
									</template>
									<!-- <template #footer>
										<van-tag plain type="primary">销量：{{item.sales}}</van-tag>
									</template> -->
								</van-card>
							</div>
							</div>
						</van-tab>
					</template>
				</van-tabs>
			</div>
		</div>
	</div>
</template>

<script>
import {getProductList, wxJSAPIConfig } from '@/assets/js/api/'
import { Notify,ImagePreview } from 'vant';
import wx from 'weixin-js-sdk';
export default {
	name: 'Home',
	data() {
		return {
			tabs:[{key:'pindex',name:'推荐'},{key:'sales',name:'销量'},{key:'price',name:'价格'}],
			hot_active:'pindex',
			product_list:{
				pindex:null,
				sales:null,
				price:null
			},
			isload: false
		}
	},
	computed:{
		productList(){
			this.product_list['pindex'] =  this.$store.getters.productList || [];
			return this.product_list;
		},
		shopInfo(){
			let _this = this;
			let item = this.$store.getters.shop || {};
			let data = {};
			for(let i in item) {
				data[i.replace('shop_', '')] = item[i];
				if(!this.isload && i == 'shop_url') {
					this.isload = true;
					_this.getWXConfig();
				}
			}
			return data;
		},
		
	},
	methods:{
		getWXConfig(){
			let _this = this;
			let _url = location.href;
			let shopInfo = this.shopInfo;
			wxJSAPIConfig({url:_url}).then(res => {
				let data = res.data;
				// console.log(data);
				wx.config({
					debug: false,//这里是开启测试，如果设置为true，打开页面时会提示是否设置成功
					appId: data.appId,//微信公众号appid
					timestamp: data.timestamp,//后台传过来的时间戳
					nonceStr: data.noncestr,//后台传过来的随机字符串
					signature: data.sign,//后台传过来的签名字符串
					jsApiList: [
						// 检查是否支持接口，分享到朋友和qq， 分享到朋友圈
						'updateAppMessageShareData',
						'updateTimelineShareData'
					]
				})
				console.log(shopInfo);
				wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
					wx.updateAppMessageShareData({ 
						title: shopInfo.name, // 分享标题
						desc: shopInfo.about, // 分享描述
						link: _url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
						imgUrl: shopInfo.logo, // 分享图标
						success: function () {
						// 设置成功
						}
					})
					wx.updateTimelineShareData({
						title: shopInfo.name, // 分享标题
						link: _url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
						imgUrl: shopInfo.logo, // 分享图标
						success: function () {
						// 用户点击了分享后执行的回调函数
						}
					})

				}); 


			}).catch(res=>{
	  			Notify({ type: 'warning', message: res.message });
			})
		},
		openProductInfo(item){
			let shop_id = this.$store.getters.shop.shop_key;
			let url = "/"+shop_id+"/product/" + item['shop_product_key'];
			this.$router.push({path: url, meta:{title: item.name} });
		},
		prerviewImages(){
			/*wx.previewImage({
				current: this.shopInfo.msg, // 当前显示图片的 http 链接
				urls: [this.shopInfo.msg] // 需要预览的图片 http 链接列表
			});
			return;*/
			// ImagePreview({images:[this.shopInfo.msg],closeable: true});
		},
		change_active(){
			this.getList();
		},
		getList(){
			getProductList({order: this.hot_active}).then((res) => {
				this.product_list[this.hot_active] = res.data.list || [];
			}).catch((res) => {
	  			Notify({ type: 'warning', message: res.message });
			})
		},
	},
	created(){
		this.change_active();
		// this.data = this.$store.shop.info;
	}
}
</script>

<style scoped>
.iphone-header {
	padding: 10px;
	display: flex;
	justify-content:space-between;
}
.iphone-header-content {
	width: calc(100% - 3.5rem);
	display: flex;
	justify-content:space-between;
}
.iphone-header-msg {
	margin-top: 7px;
	padding: 6px 13px;
}
.iphone-header-msg i {
	margin-right: 2px;
}
.iphone-header-logo {
	width: 3rem;
	overflow: hidden;
	height: 3rem;
}
.iphone-header-title, .iphone-header-desc {
	padding: 0;
	margin: 0;
}
.iphone-header-title {
	font-size: 0.98rem;
	line-height: 1.4;
	padding-bottom: .2rem;
}
.iphone-header-desc {
	font-size: 0.6rem;
	color: #999;
}
.notice-swipe {
	font-size: 0.6rem;
	height: 30px;
	background: #fff;
	margin: 0 5px;
	border-radius: 2px;
	padding: 0 10px;
}
.iphone-swipe {
	margin: 0.6rem 0;
/*	height: 10.5rem;*/
	overflow: hidden;
	background-color: #fff;
}
.iphone-swipe img {
	width: 100%;
	overflow: hidden;
	vertical-align: middle;
/*	height: 100%;*/
}
.iphone-pro {
	width: calc(50% - 0.9rem);
	display: inline-block;
	margin-left:0.6rem;
}
.iphone-pro .van-card__header {
	flex-direction: column;
}
.iphone-pro .van-card__thumb {
	width: 100%;
	height: 100%;
	text-align: center;
	margin-right: 0;
}
.iphone-pro .van-card__content {
	min-height: 3.5rem;
	height: 3.5rem;
}
.iphone-pro .van-card__desc {
	display: none;
}
.iphone-pro .van-card__price {
	font-size: 16px;
	color: #ff976a;
}
.iphone-pro .van-card__origin-price {
	text-decoration: none;
}
.iphone-pro .van-card {
	margin-top: 0.6rem;
}
.iphone-pro .van-card__footer {
	margin-top: -1rem;
	padding-bottom: .2rem
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue